<div mat-dialog-title class="dialog-top">
  <h2 mat-dialog-title>{{ 'Summary' | translate }}</h2>
  <button mat-icon-button mat-dialog-close tabindex="-1" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-content">
  <div class="cdc-summary slideContent no-scroll w-100">
    <div class="div-btns navigation" *ngIf="userRole == RoleType.ADMIN || userRole == RoleType.SALES">
      <div class="button-wrapper-left">
        <button class="cdc-button cdc-button-previous previous" mat-flat-button (click)="onCancel()">
          <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 19">
            <!-- Generator: Adobe Illustrator 29.2.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 116)  -->
            <defs>
              <style>
                .st0 {
                  fill: #fff;
                }
              </style>
            </defs>
            <polygon class="st0" points="8.9 16.3 3 9.6 8.9 2.9 10.4 4.3 5.7 9.6 10.4 15 8.9 16.3" />
          </svg>
          {{isMobile && !isEmbed ? '' : ('Amend' | translate)}}
        </button>
      </div>
      <div class="button-wrapper-right"
        [matTooltip]="!isAllRequiredFilled ? ('Verify all fields' | translate) : ''">
        <button class="cdc-button cdc-button-next done" mat-flat-button (click)="onConfirm()"
          [disabled]="blockHasErrors"
          [matTooltip]="isMobile && customerPage.blockSummary?.submitButtonText ? customerPage.blockSummary!.submitButtonText! : ''">
          <mat-icon [ngClass]="{ 'm-0': isMobile }">done_all</mat-icon>
          {{isMobile && !isEmbed ? '' : customerPage.blockSummary?.submitButtonText ?customerPage.blockSummary!.submitButtonText : ('Validate' | translate)}}
        </button>
      </div>
    </div>

    <div class="cdc-summary-block" *ngFor="let block of summaryBlocks; let i = index">
      <app-block-form [customerPage]="customerPage" [block]="block" [userRole]="userRole"
        [customersData]="customerPageDatas" (fieldContainerClick)="onFieldContainerClick($event)" [isSummary]="true"
        [offerStatus]="offerStatus" [refBusinessLists]="refBusinessLists"
        [fullConnectionsDefinitions]="fullConnectionsDefinitions">
      </app-block-form>
      <hr class="cdc-line-block" *ngIf="customerPage.blocks!.length-1 > i" />
    </div>

    <div class="div-btns navigation">
      <div class="button-wrapper-left" [ngClass]="userRole == RoleType.INTERN ? 'align-items-center' : ''">
        <button class="cdc-button cdc-button-previous previous" mat-flat-button (click)="onCancel()">
          <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 14 19">
            <!-- Generator: Adobe Illustrator 29.2.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 116)  -->
            <defs>
              <style>
                .st0 {
                  fill: #fff;
                }
              </style>
            </defs>
            <polygon class="st0" points="8.9 16.3 3 9.6 8.9 2.9 10.4 4.3 5.7 9.6 10.4 15 8.9 16.3" />
          </svg>
          {{isMobile && !isEmbed ? '' : ('Amend' | translate)}}
        </button>
      </div>
      <div *ngIf="userRole != RoleType.INTERN" class="button-wrapper-right"
        [matTooltip]="!isAllRequiredFilled ? ('Verify all fields' | translate) : ''">
        <button class="cdc-button cdc-button-next done" mat-flat-button (click)="onConfirm()"
          [disabled]="blockHasErrors"
          [matTooltip]="isMobile && customerPage.blockSummary?.submitButtonText ? customerPage.blockSummary!.submitButtonText! : ''">
          <mat-icon [ngClass]="{ 'm-0': isMobile }">done_all</mat-icon>
          {{isMobile && !isEmbed ? '' : customerPage.blockSummary?.submitButtonText ?customerPage.blockSummary!.submitButtonText : ('Validate' | translate)}}
        </button>
      </div>
    </div>

  </div>
</mat-dialog-content>
